import React from 'react';
import ReactPaginate from 'react-paginate';

const Pagination = ({
  	pageNumber,
	pageSize,
	totalRecordCount,
	onChange,
  	...props
}) => (
		<ReactPaginate props
			previousLabel={"Previous"}
			previousClassName={"pager__button"}
			nextClassName={"pager__button"}
			pageClassName={"pager__button"}
			activeClassName={"active"}
			nextLabel={"Next"}
			breakLabel={<a href="">...</a>}
			breakClassName={"pager__button"}
			pageCount={totalRecordCount > 0 ? Math.ceil(totalRecordCount / pageSize) : 0}
			forcePage={pageNumber > 0 ? pageNumber - 1 : pageNumber}
			marginPagesDisplayed={2}
			pageRangeDisplayed={5}
			onPageChange={onChange}
			containerClassName={"pager"}
			subContainerClassName={"pages pagination"}
			disabledClassName={"cursor--not-allowed "}
			activeClassName={"active"} />
	);

export { Pagination };


// WEBPACK FOOTER //
// ./src/components/Pagination.js